import { FC, ReactNode } from 'react';
import { IconProps } from '@base/icon/interface';
import { LoopRender } from '@base/snippets/LoopRender';
import { get375CssValue } from 'base/utils/dom-size';
import cn from 'classnames';
import styles from './index.module.less';

type IProps = IconProps & {
    children?: ReactNode;
    path?: string;
    paths?: string[];
};

type ISizeProps = {
    width?: string;
    height?: string;
}

const commonSvgProps = {
    viewBox: '0 0 1024 1024',
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'currentColor',
};

function getSizeProps(size: IconProps['size']): ISizeProps {
    const sizeProps = {} as {
        width?: string;
        height?: string;
    };

    if (size !== false) {
        size = size || 16;
        if (typeof size === 'number') {
            size = get375CssValue(size);
        }
        sizeProps.width = size;
        sizeProps.height = size;
    }
    return sizeProps;
}

export const SVG: FC<IProps> = props => {
    const {
        className,
        style,
        size = '1em',
        path,
        paths,
        shape = 'default',
        direction = 'up',
        onClick,
        children,
    } = props;

    const sizeProps = getSizeProps(size);

    const child = (
        <>
            {!!path && <path d={path}/>}

            <LoopRender
                tag={false}
                list={paths}
                render={path => <path d={path}/>}
            />

            {children}
        </>
    );

    if (shape !== 'default') {
        return (
            <span
                className={cn(
                    className,
                    'sw-icon',
                    { [styles[direction]]: direction && direction !== 'up' },
                    styles[shape],
                )}
                style={{ ...style, ...sizeProps }}
            >
                <svg
                    width={'100%'}
                    height={'100%'}
                    {...commonSvgProps}
                >
                    {child}
                </svg>
            </span>
        )
    }

    return (
        <svg
            className={cn(
                className,
                'sw-icon',
                { [styles[direction]]: direction && direction !== 'up' }
            )}
            style={style}
            onClick={onClick}
            {...sizeProps}
            {...commonSvgProps}
        >
            {child}
        </svg>
    )
};